import { Box } from '@chakra-ui/react';

import { Checkbox } from '@m/components-ui/checkbox';

interface SavePaymentCheckboxProps {
  checked: boolean;
  display: boolean;
  onChange: (checked: boolean) => void;
}

export function SavePaymentCheckbox({ checked, display, onChange }: SavePaymentCheckboxProps) {
  if (!display) return null;

  return (
    <Box py={4}>
      <Checkbox checked={checked} onCheckedChange={(e) => onChange(!!e.checked)}>
        Save for future Metropolis visits
      </Checkbox>
    </Box>
  );
}
